// Central store for the backend-issued token pair. The backend returns the access + refresh
// tokens in JSON (not httpOnly cookies), so we keep them in localStorage. The legacy single
// `token` key (which used to hold the raw Google ID token) is cleared whenever we write.

const ACCESS_KEY = 'accessToken'
const REFRESH_KEY = 'refreshToken'
const LEGACY_KEY = 'token'

export function getAccessToken() {
    return localStorage.getItem(ACCESS_KEY)
}

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_KEY)
}

export function setTokens({ accessToken, refreshToken }) {
    if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken)
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken)
    localStorage.removeItem(LEGACY_KEY)
}

export function clearTokens() {
    localStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(REFRESH_KEY)
    localStorage.removeItem(LEGACY_KEY)
}
